import TYPES from './types';
import { put, post } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const updateAgentTypes = params => dispatch => {
  const { id, table, ...rest } = params;

  dispatch({ type: TYPES.UPDATE_AGENTS.START, payload: params });

  return put(`/enums/agent-types/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_AGENTS.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({
        type: TYPES.UPDATE_AGENTS.ERROR,
        payload: { response: error, params }
      });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const createAgentTypes = params => dispatch => {
  const { table, ...rest } = params;

  dispatch({ type: TYPES.CREATE_AGENTS.START, payload: params });

  return post(`/enums/agent-types`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.CREATE_AGENTS.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({
        type: TYPES.CREATE_AGENTS.ERROR,
        payload: { response: error, params }
      });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};
